import { Helmet } from "react-helmet";

import FeedbackImage from "../assets/images/feedback.svg";
import PDF from "../assets/files/provido-complaints-form.pdf";

import ComplaintsForm from "../components/ComplaintsForm.tsx";

const FeedbackComplaints = () => {
  return (
    <main>
      <Helmet>
        <title>Lodge a Complaint | Provido</title>
        <meta property="og:title" content="Lodge a Complaint | Provido" />
        <meta
          name="description"
          content="If you have any issues with our services, please let us know."
        ></meta>
        <meta
          property="og:url"
          content="https://provido.com.au/contact/complaints"
        />
        <meta name="twitter:title" content="Lodge a Complaint | Provido" />
      </Helmet>

      {/* Page Header */}
      <div className="w-dvw bg-lightblue bg-[url(./assets/images/bubblebg.webp)] pt-12">
        <div className="mx-12 grid grid-cols-1 gap-8 sm:grid-cols-3 lg:mx-24 lg:gap-24">
          <div className="order-2 col-span-1 flex items-center lg:order-1">
            <img
              src={FeedbackImage}
              className="-mt-6 -mb-39 max-h-96 w-full"
              alt="Illustration: woman sitting and reading something on her phone."
            />
          </div>
          <div className="order-1 col-span-2 flex flex-col items-center justify-center pb-12 sm:order-2">
            <h1 className="text-center font-display text-6xl leading-18 text-blue">
              Lodge a Complaint
            </h1>
          </div>
        </div>
      </div>

      <div className="mx-auto w-fit max-w-3xl px-6 py-16 font-body text-xl">
        <p className="pb-4">
          We value hearing from you, whether it's a compliment, suggestion or a
          concern. Your feedback helps us grow, and ensures we're always
          delivering the best possible support. If something hasn't met your
          expectations, please know that every complaint is treated with the
          utmost care and consideration, reviewed thoroughly, and responded to
          with respect and compassion.
        </p>
        <p>
          You deserve to be heard, and we are committed to making that happen.
        </p>
      </div>

      {/* Complaints Form */}
      <div className="mx-auto w-fit max-w-3xl px-6">
        <h2 className="pb-8 text-center font-display text-4xl text-purple">
          How To Lodge a Complaint
        </h2>
        <p>
          To lodge a complaint, please complete the form below. If you would
          prefer a PDF version of this form,{" "}
          <a href={PDF} target="_blank" className="text-link">
            click here
          </a>
          .
        </p>
        <p className="pt-4">
          We ask that you please provide as much information as you can. Without
          this, we may be unable to address any issues or concerns properly. You
          can choose to remain anonymous.
        </p>
      </div>

      <ComplaintsForm />

      {/* What Happens Now */}
      <div className="mx-auto mt-24 w-fit max-w-3xl px-6">
        <h2 className="pb-8 text-center font-display text-4xl text-purple">
          What Happens Now?
        </h2>
        <p>
          Once we've received your complaint, we'll begin an investigation into
          the complaint or incident you've described to us. This includes
          gathering any required evidence and talking to those involved.
        </p>
        <p className="pt-4">
          If you have provided contact information, we may be in touch to gather
          additional details as the investigation proceeds. Please know we take
          your privacy seriously, and we will not disclose your identity to
          anyone involved without your permission.
        </p>
        <p className="pt-4">
          At the conclusion of the investigation, we may contact you to make you
          aware of the outcome.
        </p>
      </div>

      {/* Not Happy with the Outcome? */}
      <div className="mx-auto my-24 w-fit max-w-3xl px-6">
        <h2 className="pb-8 text-center font-display text-4xl text-purple">
          Not Happy With the Outcome?
        </h2>
        <p>
          If you're not happy with the outcome of our investigation, or you wish
          to take your complaint further, please feel free to contact the
          agencies below.
        </p>
        <div className="pt-4">
          <p>
            <strong>National Disability Insurance Agency</strong>
          </p>
          <ul className="text-list">
            <li>
              Call{" "}
              <a href="tel:1800800110" className="text-link">
                1800 800 110
              </a>
            </li>
            <li>Visit one of their offices in person.</li>
            <li>
              Visit{" "}
              <a
                href="https://ndis.gov.au/contact/feedback-and-complaints"
                target="_blank"
                className="text-link"
              >
                https://ndis.gov.au/contact/feedback-and-complaints
              </a>
            </li>
          </ul>
          <p>
            <strong>Quality and Safeguards Commission</strong>
          </p>
          <ul className="text-list">
            <li>
              Call{" "}
              <a href="tel:1800035544" className="text-link">
                1800 035 544
              </a>
            </li>
            <li>
              Visit{" "}
              <a
                href="https://ndiscommission.gov.au/about/making-complaint"
                target="_blank"
                className="text-link"
              >
                https://ndiscommission.gov.au/about/making-complaint
              </a>
            </li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default FeedbackComplaints;
